import { TopicSaveDto, WebinarServiceError } from "../types/dto";
import { slugifyTopicName } from "../services/apiMappers";
import { pickTopicColor } from "../utils/pickTopicColor";

export type BuildTopicOptions = {
  id?: string;
  color?: string;
  /** Existing topic fg colors — used to keep new topics unique. */
  usedColors?: string[];
};

export function buildTopicPayload(
  name: string,
  opts: BuildTopicOptions = {},
): TopicSaveDto {
  const trimmed = name.trim().slice(0, 24);
  if (!trimmed) {
    throw new WebinarServiceError("VALIDATION", "Topic name is required");
  }
  if (trimmed.length < 2) {
    throw new WebinarServiceError(
      "VALIDATION",
      "Topic name must be at least 2 characters",
    );
  }
  const paletteColor =
    opts.color || pickTopicColor(opts.usedColors || []);
  return {
    id: opts.id,
    name: trimmed,
    slug: slugifyTopicName(trimmed),
    color: paletteColor,
  };
}
